/**
 * @generated SignedSource<<751eb046f15bf8f9f3568663d8dfe42e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectStateValue = "archived" | "at_risk" | "cancelled" | "done" | "off_track" | "on_track" | "paused" | "pending";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectViewQuery$variables = {
  includeDraftUpdate: boolean;
  key: string;
  trackViewEvent?: TrackViewEvent | null;
};
export type ProjectViewQuery$data = {
  readonly project: {
    readonly ari: string;
    readonly key: string;
    readonly members: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly name: string;
    readonly state: {
      readonly value: ProjectStateValue | null;
    } | null;
    readonly uuid: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectArchivedPanel" | "ProjectContent" | "useRedirectToDefaultTab">;
  } | null;
};
export type ProjectViewQuery = {
  response: ProjectViewQuery$data;
  variables: ProjectViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraftUpdate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v3 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "ari"
},
v8 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v9 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v12 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v13 = {
  "kind": "ScalarField",
  "name": "picture"
},
v14 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v15 = {
  "kind": "ScalarField",
  "name": "__id"
},
v16 = {
  "kind": "ClientExtension",
  "selections": [
    (v15/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v18 = {
  "kind": "ScalarField",
  "name": "targetDateConfidence"
},
v19 = {
  "kind": "ScalarField",
  "name": "count"
},
v20 = {
  "kind": "ScalarField",
  "name": "summary"
},
v21 = {
  "kind": "ScalarField",
  "name": "title"
},
v22 = {
  "kind": "ScalarField",
  "name": "modifiedDate"
},
v23 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v5/*: any*/),
        (v13/*: any*/)
      ]
    },
    (v10/*: any*/)
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "status"
},
v25 = {
  "kind": "ScalarField",
  "name": "description"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectViewQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v3/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "utils_isUserInList",
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "argumentDefinitions": []
              }
            ]
          },
          (v9/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "ProjectArchivedPanel"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "includeDraftUpdate",
                "variableName": "includeDraftUpdate"
              }
            ],
            "kind": "FragmentSpread",
            "name": "ProjectContent"
          },
          {
            "kind": "FragmentSpread",
            "name": "useRedirectToDefaultTab"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectViewQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v3/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "ScalarField",
            "name": "watching"
          },
          {
            "kind": "ScalarField",
            "name": "userUpdateCount"
          },
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "theWhat"
          },
          {
            "kind": "ScalarField",
            "name": "theWhy"
          },
          {
            "kind": "ScalarField",
            "name": "theMeasurement"
          },
          {
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "WorkspaceAIConfig",
                "kind": "LinkedField",
                "name": "aiConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "enabled"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "CommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
              {
                "concreteType": "CommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "commentText"
                      },
                      (v12/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountStatus"
                              },
                              (v14/*: any*/)
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v16/*: any*/)
            ]
          },
          (v17/*: any*/),
          (v18/*: any*/),
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v19/*: any*/)
            ]
          },
          (v12/*: any*/),
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "concreteType": "ProjectUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v20/*: any*/),
              {
                "concreteType": "UpdateNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v21/*: any*/),
                  (v20/*: any*/),
                  (v10/*: any*/)
                ]
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "hasUpdateId",
                "value": false
              }
            ],
            "concreteType": "ProjectChangelogItemConnection",
            "kind": "LinkedField",
            "name": "changelog",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "concreteType": "ProjectChangelogItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ProjectChangelogItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "newValue"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "oldValue"
                      },
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "changelog(hasUpdateId:false)"
          },
          {
            "concreteType": "DraftUpdate",
            "kind": "LinkedField",
            "name": "draftUpdate",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "input"
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v10/*: any*/),
              (v16/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "concreteType": "UpdateGenerationSettings",
            "kind": "LinkedField",
            "name": "updateGenerationSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "templateKey"
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "pendingUpdateAttatchment",
                    "value": true
                  }
                ],
                "concreteType": "MilestoneConnection",
                "kind": "LinkedField",
                "name": "milestones_extension",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MilestoneEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Milestone",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v4/*: any*/),
                          (v21/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "targetDateType"
                          },
                          (v24/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "milestones_extension(first:10,pendingUpdateAttatchment:true)"
              },
              (v15/*: any*/)
            ]
          },
          {
            "condition": "includeDraftUpdate",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "ProjectDraftUpdate",
                "kind": "LinkedField",
                "name": "latestDraftUpdate",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v23/*: any*/),
                  (v22/*: any*/),
                  {
                    "concreteType": "Project",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v10/*: any*/)
                    ]
                  },
                  (v20/*: any*/),
                  (v24/*: any*/),
                  {
                    "concreteType": "TargetDateInputDraft",
                    "kind": "LinkedField",
                    "name": "targetDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "date"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "confidence"
                      }
                    ]
                  },
                  {
                    "concreteType": "UpdateNoteInputDraft",
                    "kind": "LinkedField",
                    "name": "updateNotes",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v25/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "UpdateHighlightInputDraft",
                    "kind": "LinkedField",
                    "name": "highlights",
                    "plural": true,
                    "selections": [
                      (v20/*: any*/),
                      (v25/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1307e53c9673e92579729d793e7856cc",
    "id": null,
    "metadata": {},
    "name": "ProjectViewQuery",
    "operationKind": "query",
    "text": "query ProjectViewQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $includeDraftUpdate: Boolean!\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    uuid\n    name\n    key\n    ari\n    members {\n      ...utils_isUserInList\n    }\n    state {\n      value\n    }\n    ...ProjectArchivedPanel\n    ...ProjectContent_2ND2m7\n    ...useRedirectToDefaultTab\n    id\n  }\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment DraftEnabledProjectPageUpdateComposer on Project {\n  id\n  ari\n  state {\n    value\n  }\n  targetDate\n  targetDateConfidence\n  ...ProjectUpdateComposer\n  ...ProjectDraftUpdatePost\n  latestDraftUpdate {\n    ...ProjectDraftUpdateAdapter_draft\n    id\n  }\n}\n\nfragment DraftProjectUpdate on DraftUpdate {\n  input\n  modifiedDate\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n}\n\nfragment NewProjectUpdate on Project {\n  id\n  key\n  uuid\n  workspace {\n    uuid\n    id\n  }\n  watchers {\n    count\n  }\n  creationDate\n  startDate\n  targetDate\n  state {\n    value\n  }\n  latestUserUpdate {\n    id\n    editDate\n    creationDate\n    summary\n    notes {\n      title\n      summary\n      id\n    }\n  }\n  ...ProjectTargetDateAutoUpdated\n  capabilities {\n    ...StateAndDatePicker_capabilities\n  }\n  draftUpdate {\n    ...DraftProjectUpdate\n    input\n    id\n  }\n  url\n  ...ProjectDraftWithRovoField\n  ...StateAndDatePicker_project\n}\n\nfragment ProjectAboutTab on Project {\n  capabilities {\n    canEditMetadata\n  }\n  ...ProjectDescription\n  ...ProjectComments\n}\n\nfragment ProjectArchivedPanel on Project {\n  id\n  state {\n    value\n  }\n}\n\nfragment ProjectComments on Project {\n  id\n  uuid\n  ari\n  workspace {\n    uuid\n    id\n  }\n  comments {\n    edges {\n      node {\n        id\n      }\n    }\n    ...Comments\n  }\n}\n\nfragment ProjectContent_2ND2m7 on Project {\n  watching\n  userUpdateCount\n  ...ProjectAboutTab\n  ...ProjectUpdatesTab_2ND2m7\n}\n\nfragment ProjectDescription on Project {\n  id\n  uuid\n  name\n  theWhat\n  theWhy\n  theMeasurement\n  workspace {\n    uuid\n    id\n  }\n}\n\nfragment ProjectDraftUpdateAdapter_draft on ProjectDraftUpdate {\n  id\n  author {\n    pii {\n      accountId\n      name\n      picture\n    }\n    id\n  }\n  modifiedDate\n  project {\n    state {\n      value\n    }\n    targetDate\n    targetDateConfidence\n    id\n  }\n  summary\n  status\n  targetDate {\n    date\n    confidence\n  }\n  updateNotes {\n    summary\n    description\n    uuid\n  }\n  highlights {\n    summary\n    description\n    type\n  }\n}\n\nfragment ProjectDraftUpdatePost on Project {\n  id\n  ari\n  startDate\n  state {\n    value\n  }\n}\n\nfragment ProjectDraftWithRovoField on Project {\n  ...ProjectUpdateComposerDraftWithRovoButton\n}\n\nfragment ProjectDraftWithRovoField_ComposerButton on Project {\n  ...ProjectUpdateComposerDraftWithRovoButton\n}\n\nfragment ProjectPageUpdateComposer_2ND2m7 on Project {\n  ...ProjectUpdateComposer\n  ...DraftEnabledProjectPageUpdateComposer @include(if: $includeDraftUpdate)\n}\n\nfragment ProjectStatePickerWrapper on TownsquareProjectCapabilities {\n  ...ProjectStatePicker_statusCapabilities\n}\n\nfragment ProjectStatePicker_statusCapabilities on TownsquareProjectCapabilities {\n  canEditStatus\n}\n\nfragment ProjectTargetDateAutoUpdated on Project {\n  key\n  targetDate\n  changelog(hasUpdateId: false) {\n    count\n    edges {\n      node {\n        newValue\n        oldValue\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectUpdateComposer on Project {\n  ...ProjectUpdateDueDateContext\n  ...NewProjectUpdate\n  latestUserUpdate {\n    id\n  }\n  draftUpdate {\n    ...DraftProjectUpdate\n    id\n  }\n  id\n  ari\n  uuid\n  workspace {\n    uuid\n    aiConfig {\n      enabled\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateComposerDraftWithRovoButton on Project {\n  ari\n  updateGenerationSettings {\n    templateKey\n  }\n}\n\nfragment ProjectUpdateDueDateContext on Project {\n  state {\n    value\n  }\n  latestUpdateDate\n}\n\nfragment ProjectUpdatesTab_2ND2m7 on Project {\n  key\n  state {\n    value\n  }\n  watching\n  targetDate\n  targetDateConfidence\n  ...ProjectPageUpdateComposer_2ND2m7\n  draftUpdate {\n    id\n  }\n}\n\nfragment StateAndDatePicker_capabilities on TownsquareProjectCapabilities {\n  canEditTargetDate\n  ...ProjectStatePickerWrapper\n}\n\nfragment StateAndDatePicker_project on Project {\n  ...ProjectDraftWithRovoField_ComposerButton\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment useRedirectToDefaultTab on Project {\n  watching\n  key\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "61d3aea88074432f57b9ecafdafae994";

export default node;
